<div class="flex space-x-3">
    <div *ngFor="let step of steps">
        <img src="assets/icons/icon-dot-blue.svg" class="cursor-pointer"
         [hidden]="!step.isActive" alt="asc"
         (click)="setStepActive(step)"/>
        <img src="assets/icons/icon-dot-gray.svg" class="cursor-pointer"
         [hidden]="step.isActive" alt="asc"
         (click)="setStepActive(step)"/>
    </div>
    
</div>
